<template>
  <rabbey-table
    ref="r"
    :headers="headers"
    :actions="options"
    index-url="/api/CMI/Perpectives/All"
    @push:action="hanleAction"
    @get:data="getdata"
    :callback-index="handleTable"
  />
</template>

<script>
const HEADERS = [
  {
    prop: "Id",
    name: "ID",
    width: 80,
    sortable: true
  },

  {
    sortable: true,
    prop: "Name",
    name: "Nombre"
  },
  {
    prop: "Description",
    name: "Descripcion"
  }
];
const Opts = [0];

export default {
  name: "Perpectivas",

  /* make instance for other objects */
  data() {
    return {
      loading: false,
      headers: HEADERS,
      options: Opts
    };
  },
  mounted() {
    this.getdata();
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    hanleAction(arg) {},
    getdata() {
      // calling method get in the table
      this.$refs.r.getData();
    },
    handleTable(_resp) {
      const { data } = _resp;
      // Este metodo es para manejar la respuesta que no son PageModel<Entidad>
      const table = this.$refs.r;
      table.items = data;
    }
  }
};
</script>
<style></style>
